import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createTheme, FormControl, ThemeProvider, Button } from "@material-ui/core";
import stylesPc from "../../viewer/UploadSlideStock.module.css";
import stylesSp from "../../viewer/UploadSlideStock_SP.module.css";
import styleIpad from "../../viewer/UploadSlideStock_IP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import TextField from "@material-ui/core/TextField";
import { Chip, createStyles, makeStyles } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import { AppState } from "../../../root/RootReducer";
import { ExtractFileName } from "../../../utils/ObjectUtils";
import UploadDocument from "../../../pages/vod/Common/UploadDocument";
import { countCharLength } from "../../../utils/ValidationUtils";
import { Group } from "../../../user/User";
import PuiMessage from "../../../components/widgets/PuiMessage";
import Modal from "@material-ui/core/Modal";
import SelectTag from "../SelectTag";
import SelectGroup from "../../../pages/admin/EditUser/SelectGroup";
import { CreateTempFile, DeleteTempFile } from "../../../store/actions/SlideActions";
import OnLeaveDialog from "../../../common/components/dialog/OnLeaveDialog";
import { VideoExtraMaterial } from "../../../common/video/models/VideoExtraMaterial";
import { ResetDuplicateError } from "../../../common/video/VideoActions";
import { GetGroupList } from "../../../user/UserActions";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

interface SlideStockInfoDetailProps {
    setIsSaved: (isSaved: boolean) => void;
    // コンテンツファイル
    inputSlideFile: any;
    InputSlideFile: (inputSlideFile: any) => void;
    textUploadSlide: string;
    ChangeTextUploadSlide: (textUploadSlide: string) => void;
    // タイトル
    inputSlideName: string;
    InputSlideName: (inputSlideName: string) => void;
    // プロフェッショナル
    inputSlideProfessional: number;
    InputSlideProfessional: (inputSlideProfessional: number) => void;
    // 要約
    inputSlideDetail: string;
    InputSlideDetail: (inputSlideDetail: string) => void;
    // タイトルエラー
    isErrorTitleValidation: boolean;
    CheckTitleValidation: (isErrorTitleValidation: boolean) => void;
    // 要約エラー
    isErrorDescriptionValidation: boolean;
    CheckDescriptionValidation: (isErrorDescriptionValidation: boolean) => void;
    // 資料
    inputDocumentList: any[];
    ChangeDocumentList: (documentList: any[]) => void;
    inputDocumentNameList: string[];
    ChangeDocumentNameList: (documentNameList: string[]) => void;
    // 詳細情報入力
    showDetailInfoBtn: boolean;
    handleDetailInfoBtn: () => void;
    // タグ
    tagList: string[];
    setTagList: (tagList: string[]) => void;
    // グループ
    group: Group[];
    setGroup: (group: Group[]) => void;
    // 資料アップロード
    alreadyUploadDocumentList?: VideoExtraMaterial[];
    ChangeAlreadyUploadDocumentList?: (tagList: VideoExtraMaterial[]) => void;
    isEditModal?: boolean;
}

const useStyles = makeStyles(() =>
    createStyles({
        input: {
            width: "100%",
            fontFamily: "noto-sans-cjk-jp !important",
            "& .MuiInputBase-root": {
                // color: "white",
                "& .MuiOutlinedInput-notchedOutline": {
                    // borderColor: "white",
                },
            },
            "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                    borderColor: "var(--main)",
                },
            },
        },
        select: {
            // color: "white",
            fontFamily: "noto-sans-cjk-jp !important",
            "& .MuiOutlinedInput-notchedOutline": {
                // borderColor: "white",
            },
            "& .MuiSelect-iconOutlined": {
                // color: "white",
            },
        },
        title: {
            width: IsDevice("iphone") ? "100%" : "440px",
            background: "#FFFFFF0D",
            borderRadius: "5px",
            fontWeight: "bold",
            "& .MuiInputBase-root": {
                height: "40px",
                "& .MuiInputBase-input": {
                    border: "none",
                    color: "white",
                    fontFamily: "Yu Gothic",
                },
            },
        },
        formSelect: {
            border: "1px solid rgba(255, 255, 255, 0.3)",
            width: IsDevice("iphone") ? "100%" : "440px",
            height: "40px",
            fontSize: "14px",
            background: "#FFFFFF0D",
            borderRadius: "5px",
            fontFamily: "Yu Gothic",
            "& .MuiSelect-icon": {
                color: "white",
            },
            "& .MuiSelect-selectMenu": {
                color: "white",
            },
        },
        menuItem: {
            backgroundColor: "#323438",
            color: "rgba(255, 255, 255, 0.3)",
            "&:hover": {
                color: "rgba(255, 255, 255, 0.6)",
                backgroundColor: "rgba(1, 1, 1, 0.5)",
            },
            // "& .MuiButtonBase-root": {
            //     color: "rgba(1, 1, 1, 0.5)",
            // },
        },
        textField: {
            width: IsDevice("iphone") ? "100%" : "440px",
            minHeight: IsDevice("iphone") ? "none" : "200px",
            overflowY: "auto",
            background: "#FFFFFF0D",
            border: "none",
            borderRadius: "5px",
            "& .MuiInputBase-root": {
                minHeight: "200px",
                "& .MuiInputBase-input": {
                    height: "173px !important",
                    color: "white",
                    fontFamily: "Yu Gothic",
                },
            },
        },
    })
);

export default function SlideStockInfoDetail({
    setIsSaved,
    showDetailInfoBtn,
    // コンテンツファイル
    inputSlideFile,
    InputSlideFile,
    textUploadSlide,
    ChangeTextUploadSlide,
    // タイトル
    inputSlideName,
    InputSlideName,
    // プロフェッショナル
    inputSlideProfessional,
    InputSlideProfessional,
    // 要約
    inputSlideDetail,
    InputSlideDetail,
    // タイトルエラー
    isErrorTitleValidation,
    CheckTitleValidation,
    // 要約エラー
    isErrorDescriptionValidation,
    CheckDescriptionValidation,
    // 資料
    ChangeDocumentList,
    inputDocumentList,
    ChangeDocumentNameList,
    inputDocumentNameList,
    handleDetailInfoBtn,
    // タグ
    tagList,
    setTagList,
    // グループ
    group,
    setGroup,
    // 資料アップロード
    alreadyUploadDocumentList,
    ChangeAlreadyUploadDocumentList,
    isEditModal,
}: SlideStockInfoDetailProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : IsDevice("ipad") ? styleIpad : stylesSp;

    const classes = useStyles();
    const dispatch = useDispatch();

    const theme = createTheme({
        palette: {
            secondary: {
                main: isEditModal ? "#16ADC1" : "#12e07e",
            },
        },
    });

    // ユーザー取得
    const { professionals, groupList } = useSelector((state: AppState) => ({
        professionals: state.user.userInfoList,
        groupList: state.user.groupList,
    }));

    // tempFile取得
    const { tempFile } = useSelector((state: AppState) => ({
        tempFile: state.slide.tempFile,
    }));

    // コンテンツ用
    const inputSlideRef = useRef<HTMLInputElement>(null);

    // コンテンツアップロード
    const [inputSlideFileName, InputSlideFileName] = useState("");
    // 再度別のコンテンツアップロード
    const [inputNextSlideFile, InputNextSlideFile] = useState<File | null>(null);

    // ファイルサイズ
    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);

    // ファイルサイズ制限バー消去
    const CloseLimitInputFileBar = () => {
        ChangeLimitInputFileSize(false);
    };

    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
    };

    // コンテンツ内容リセット
    useEffect(() => {
        if (tempFile.keyName === "" && !inputSlideName) {
            // コンテンツファイル
            ChangeTextUploadSlide("アップロードするファイルを選択（50MBまで）");
            InputSlideFileName("");
            if (inputSlideRef.current) {
                inputSlideRef.current.value = "";
            }
            setIsSaved(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tempFile.keyName]);

    // コンテンツアップロードテキストサーズ
    const [isLimitInputFileSize, ChangeLimitInputFileSize] = useState(false);
    // 既にファイルがアップロードして再度別のファイルをアップロードする場合、ダイアログ表示変数定義
    const [showSlideUploadConfirmDialog, setShowSlideUploadConfirmDialog] = useState(false);
    const UserUploadSlide = (event: any) => {
        if (event.target.files.length === 0) {
            ChangeTextUploadSlide("アップロードするファイルを選択（50MBまで）");
            InputSlideFile(null);
            InputSlideFileName("");
            if (inputSlideRef.current) {
                inputSlideRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 1024 * 1024 * 50) {
                    ChangeLimitInputFileSize(true);
                    if (inputSlideRef.current) {
                        inputSlideRef.current.value = "";
                    }
                } else {
                    // 既にファイルがアップロードして再度別のファイルをアップロードする場合、
                    if (tempFile.keyName !== "") {
                        // 再度別のファイルをアップロードするとき、変数に保存
                        InputNextSlideFile(event.target.files[0]);
                        setShowSlideUploadConfirmDialog(true);
                    } else {
                        // ファイルアップロードAPI CAll
                        dispatch(CreateTempFile(event.target.files[0]));
                        // ファイルアップロードするとき、変数に保存
                        InputSlideFile(event.target.files[0]);
                        InputSlideFileName(event.target.files[0].name);
                        InputSlideName(ExtractFileName(event.target.files[0].name));
                        ChangeTextUploadSlide(event.target.files[0].name);
                    }
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputSlideRef.current) {
                    inputSlideRef.current.value = "";
                }
            }
        } else {
            ChangeTextUploadSlide("ファイルを正しく選択してください（50MBまで）");
            InputSlideFile(null);
            InputSlideFileName("");
            if (inputSlideRef.current) {
                inputSlideRef.current.value = "";
            }
        }
        setIsSaved(false);
    };

    // 既にファイルがアップロードして再度別のファイルをアップロードする場合、ダイアログ処理
    const handleCloseDialog = () => {
        setShowSlideUploadConfirmDialog(false);
    };
    const handleCancelDialog = () => {
        // ダイアログ表示閉じる
        handleCloseDialog();
    };

    // 既にファイルがアップロードして再度別のファイルをアップロードする場合、以前のTempFileを削除
    const deleteTempFile = () => {
        // tempFileデータをクリアする
        dispatch(DeleteTempFile(tempFile.keyName));
        // 再度別のファイルをアップロードする
        if (inputNextSlideFile) {
            dispatch(CreateTempFile(inputNextSlideFile));
            // 再度別のファイルをアップロードするとき、変数に保存
            InputSlideFileName(inputNextSlideFile.name);
            InputSlideName(ExtractFileName(inputNextSlideFile.name));
            ChangeTextUploadSlide(inputNextSlideFile.name);
            // アップロード終わった後、InputSlideFile変数に反映する
            InputSlideFile(inputNextSlideFile);
        }
        // ダイアログ表示閉じる
        handleCloseDialog();
    };

    // コンテンツタイトル入力
    const ChangeTitle = (event: any) => {
        if (countCharLength(event.target.value) > 80) {
            CheckTitleValidation(true);
        } else {
            CheckTitleValidation(false);
        }
        InputSlideName(event.target.value);
        setIsSaved(false);
    };

    // プロフェッショナル
    const UserInputSlideProfessional = (event: any) => {
        InputSlideProfessional(event.target.value);
        setIsSaved(false);
    };

    // グループ選択
    const UserInputVideoGroup = (event: any) => {
        const groupNames: string[] = event.target.value;
        if (groupNames.includes("選択なし")) groupNames.splice(0, 1);
        const tempGroups: Group[] = [];
        groupList.forEach((group) => {
            if (groupNames.includes(group.title)) {
                tempGroups.push(group);
            }
        });
        setGroup(tempGroups);
        setIsSaved(false);
    };

    // コンテンツ要約入力
    const ChangeDescription = (event: any) => {
        if (countCharLength(event.target.value) > 400) {
            CheckDescriptionValidation(true);
        } else {
            CheckDescriptionValidation(false);
        }
        InputSlideDetail(event.target.value);
        setIsSaved(false);
    };

    // タグ選択モーダル画面表示制御
    const [isOpenTagSelectModal, ShowTagSelectModal] = useState(false);
    const OpenTagSelectModal = () => {
        ShowTagSelectModal(true);
    };
    const CloseTagSelectModal = () => {
        ShowTagSelectModal(false);
        dispatch(ResetDuplicateError());
    };
    const handleDelete = (tagName: string) => {
        const newList = tagList.filter((v) => v !== tagName);
        setTagList(newList);
        setIsSaved(false);
    };

    //Addアイコンにマウス入る処理
    const [isMouseEnterInfo, setMouseEnterInfo] = useState<boolean>(false);

    // グループ選択モーダル画面表示制御
    const [isOpenGroupSelectModal, ShowGroupSelectModal] = useState(false);
    const OpenGroupSelectModal = () => {
        ShowGroupSelectModal(true);
    };
    const CloseGroupSelectModal = () => {
        ShowGroupSelectModal(false);
    };
    const SetSlideGroup = (updateGroupList: Group[]) => {
        setGroup(updateGroupList);
        setIsSaved(false);
    };
    const handleDeleteGroup = (groupName: string) => {
        const newList: Group[] = group.filter((v) => v.title !== groupName);
        setGroup(newList);
        setIsSaved(false);
    };

    // ブラウザをリフレッシュ・閉じるとき、tempfileを削除
    const deleteTempFileBeforeUnload = (event?: any) => {
        event.preventDefault();
        if (tempFile.keyName) {
            const storeTempFile = localStorage.getItem("tempFileKeyName");
            if (storeTempFile !== "" && storeTempFile !== tempFile.keyName) {
                if (storeTempFile) dispatch(DeleteTempFile(storeTempFile));
            }
            // tempFile.keyNameをsessionストレージに保存する
            localStorage.setItem("tempFileKeyName", tempFile.keyName);
        }
        event.returnValue = "";
    };

    useEffect(() => {
        if (groupList && groupList.length === 0) {
            dispatch(GetGroupList());
        }
        // eslint-disable-next-line
    }, []);

    // ブラウザをリフレッシュ・閉じるとき、イベント
    useEffect(() => {
        if (tempFile.keyName) window.addEventListener("beforeunload", deleteTempFileBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", deleteTempFileBeforeUnload);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tempFile]);

    // 初期表示、localStorageのTempFileを削除
    useEffect(() => {
        const storeTempFile = localStorage.getItem("tempFileKeyName");
        if (!tempFile.keyName && storeTempFile !== null) {
            dispatch(DeleteTempFile(storeTempFile));
            localStorage.removeItem("tempFileKeyName");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <ul className={`${styles.inputForm} ${isEditModal ? styles.isEditModal : ""}`}>
                <FormControl className={styles.formControl}>
                    <form name="addFileForm" id="addFileForm">
                        {/*PDF, PPT, PPTX, DOC, DOCXファイル */}
                        <li>
                            <div className={styles.formHelperText}>
                                スライド
                                {!isEditModal && (
                                    <span style={{ color: "var(--red)", fontSize: 15 }}>＊</span>
                                )}
                            </div>
                            <div
                                className={styles.form}
                                style={{
                                    color: isEditModal ? "rgba(255, 255, 255, 0.3)" : "black",
                                    marginLeft: isEditModal ? "20px" : "",
                                    width: isEditModal ? "280px" : "",
                                    height: isEditModal ? "40px" : "",
                                    background: "rgba(255, 255, 255, 0.05)",
                                    borderRadius: "5px",
                                }}
                            >
                                <label
                                    className={styles.uploadButton}
                                    style={{ cursor: isEditModal ? "default" : "pointer" }}
                                >
                                    {isEditModal ? (
                                        <input
                                            ref={inputSlideRef}
                                            id="browserSlideUploader"
                                            className={styles.fileDisplay}
                                        />
                                    ) : (
                                        <input
                                            ref={inputSlideRef}
                                            id="browserSlideUploader"
                                            accept=".pdf,.pptx,.ppt,.doc,.docx"
                                            multiple
                                            type="file"
                                            onChange={UserUploadSlide}
                                            className={styles.fileDisplay}
                                        />
                                    )}
                                    <input
                                        ref={inputSlideRef}
                                        id="browserSlideUploader"
                                        accept=".pdf,.pptx,.ppt,.doc,.docx"
                                        multiple
                                        type="file"
                                        onChange={UserUploadSlide}
                                        className={styles.fileDisplay}
                                    />
                                    {textUploadSlide}
                                </label>
                            </div>
                            {/* handleDetailInfoBtn */}
                            <div className={styles.updateButtonDiv}>
                                {showDetailInfoBtn ? (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        type="submit"
                                        onClick={handleDetailInfoBtn}
                                        style={{
                                            marginLeft: "10px",
                                            width: isEditModal ? "144px" : "",
                                            height: "40px",
                                            fontSize: isEditModal ? "16px" : "",
                                            color: isEditModal ? "white" : "var(--main)",
                                            backgroundColor: isEditModal
                                                ? "var(--studio-btn-bg)"
                                                : "none",
                                            borderColor: isEditModal ? "none" : "var(--main)",
                                            fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        }}
                                        className={styles.updateButton}
                                    >
                                        詳細情報入力
                                    </Button>
                                ) : (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        disabled
                                        type="submit"
                                        color="secondary"
                                        className={styles.updateButton}
                                        style={{
                                            width: isEditModal ? "144px" : "",
                                            height: "40px",
                                            marginLeft: "10px",
                                            fontSize: isEditModal ? "16px" : "",
                                            color: "var(--gray-85)",
                                            borderColor: "var(--gray-85)",
                                            fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        }}
                                    >
                                        詳細情報入力
                                    </Button>
                                )}
                            </div>
                        </li>

                        {/* タイトル */}
                        <ThemeProvider theme={theme}>
                            <li>
                                <div className={styles.formHelperText}>
                                    タイトル
                                    {!isEditModal && (
                                        <span style={{ color: "var(--red)", fontSize: 15 }}>
                                            ＊
                                        </span>
                                    )}
                                </div>
                                <div className={styles.form}>
                                    {!isEditModal ? (
                                        <TextField
                                            color="secondary"
                                            className={classes.input}
                                            id="SlideName"
                                            variant="outlined"
                                            placeholder="Slideタイトルを入力"
                                            autoComplete="off"
                                            value={inputSlideName}
                                            onChange={ChangeTitle}
                                            error={isErrorTitleValidation}
                                            helperText={
                                                isErrorTitleValidation && (
                                                    <span style={{ color: "var(--main)" }}>
                                                        全角40文字（半角80文字）以内で正しく入力してください
                                                    </span>
                                                )
                                            }
                                        />
                                    ) : (
                                        <TextField
                                            color="secondary"
                                            className={classes.title}
                                            id="SlideName"
                                            variant="outlined"
                                            placeholder="Slideタイトルを入力"
                                            autoComplete="off"
                                            value={inputSlideName}
                                            onChange={ChangeTitle}
                                            error={isErrorTitleValidation}
                                            helperText={
                                                isErrorTitleValidation && (
                                                    <span style={{ color: "var(--studio-btn-bg)" }}>
                                                        全角40文字（半角80文字）以内で正しく入力してください
                                                    </span>
                                                )
                                            }
                                        />
                                    )}
                                </div>
                            </li>

                            {/* プロフェッショナル */}
                            {!isEditModal && (
                                <li>
                                    <div className={styles.formHelperText}>
                                        Presenter
                                        <span style={{ color: "var(--red)", fontSize: 15 }}>
                                            ＊
                                        </span>
                                    </div>
                                    <div className={styles.form}>
                                        <Select
                                            color="secondary"
                                            id="selectProfessional"
                                            variant="outlined"
                                            defaultValue="-1"
                                            onChange={UserInputSlideProfessional}
                                            value={inputSlideProfessional}
                                            className={classes.select}
                                        >
                                            <MenuItem value={-1}>Presenterを選択</MenuItem>
                                            {professionals !== undefined &&
                                                professionals.map(
                                                    (row) =>
                                                        row.roles.includes("PRESENTER") && (
                                                            <MenuItem key={row.id} value={row.id}>
                                                                {row.fullName}
                                                            </MenuItem>
                                                        )
                                                )}
                                        </Select>
                                    </div>
                                </li>
                            )}
                            {isEditModal && (
                                <li>
                                    <div className={styles.formHelperText}>プレゼンター</div>
                                    <div className={styles.form}>
                                        <Select
                                            color="secondary"
                                            id="selectProfessional"
                                            variant="outlined"
                                            onChange={UserInputSlideProfessional}
                                            value={inputSlideProfessional}
                                            className={classes.formSelect}
                                        >
                                            {professionals !== undefined &&
                                                professionals.map(
                                                    (row) =>
                                                        row.roles.includes("PRESENTER") && (
                                                            <MenuItem
                                                                key={row.id}
                                                                value={row.id}
                                                                className={classes.menuItem}
                                                                style={{
                                                                    color:
                                                                        inputSlideProfessional ===
                                                                        Number(row.id)
                                                                            ? "rgba(1, 1, 1, 0.5)"
                                                                            : "rgba(255, 255, 255, 0.6)",
                                                                }}
                                                            >
                                                                {row.fullName}
                                                            </MenuItem>
                                                        )
                                                )}
                                        </Select>
                                    </div>
                                </li>
                            )}

                            {isEditModal && (
                                <li className={styles.mb50}>
                                    <div className={styles.formHelperTextLong}>グループ</div>
                                    <div className={styles.formTag}>
                                        <Select
                                            color="secondary"
                                            id="group-select"
                                            variant="outlined"
                                            onChange={UserInputVideoGroup}
                                            value={group.map((group) => group.title)}
                                            multiple
                                            displayEmpty
                                            renderValue={(selected: any) => {
                                                if (selected.length === 0) {
                                                    return <em>選択なし</em>;
                                                }

                                                return selected.join(", ");
                                            }}
                                            MenuProps={{
                                                getContentAnchorEl: null,
                                                anchorOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left",
                                                },
                                                transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left",
                                                },
                                            }}
                                            className={classes.formSelect}
                                            style={{
                                                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                                            }}
                                        >
                                            <MenuItem disabled value="">
                                                <em>選択なし</em>
                                            </MenuItem>
                                            {groupList &&
                                                groupList.map((row) => (
                                                    <MenuItem
                                                        key={row.id}
                                                        value={row.title}
                                                        className={classes.menuItem}
                                                        style={{
                                                            color: group.some(
                                                                (group) => group.title === row.title
                                                            )
                                                                ? "#fff"
                                                                : "rgba(255, 255, 255, 0.6)",
                                                            background: group.some(
                                                                (group) => group.title === row.title
                                                            )
                                                                ? "rgba(1, 1, 1, 0.5)"
                                                                : "",
                                                        }}
                                                    >
                                                        {row.title}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </div>
                                </li>
                            )}

                            {/* 要約 */}
                            {!isEditModal && (
                                <li>
                                    <div className={styles.formHelperTextLong}>
                                        要約
                                        <span style={{ color: "var(--red)", fontSize: 15 }}>
                                            ＊
                                        </span>
                                    </div>
                                    <div className={styles.form}>
                                        <TextField
                                            color="secondary"
                                            id="description"
                                            onChange={ChangeDescription}
                                            className={classes.input}
                                            multiline
                                            minRows={5}
                                            autoComplete="off"
                                            value={inputSlideDetail}
                                            variant="outlined"
                                            placeholder="Slide要約を入力"
                                            error={isErrorDescriptionValidation}
                                            helperText={
                                                isErrorDescriptionValidation && (
                                                    <span style={{ color: "var(--main)" }}>
                                                        全角200文字（半角400文字）以内で正しく入力してください
                                                    </span>
                                                )
                                            }
                                        />
                                    </div>
                                </li>
                            )}

                            {isEditModal && (
                                <li>
                                    <div className={styles.formHelperTextLong}>内容</div>
                                    <div className={styles.form}>
                                        <TextField
                                            color="secondary"
                                            id="description"
                                            onChange={ChangeDescription}
                                            className={classes.textField}
                                            multiline
                                            minRows={5}
                                            autoComplete="off"
                                            value={inputSlideDetail}
                                            variant="outlined"
                                            placeholder="内容を入力してください"
                                            error={isErrorDescriptionValidation}
                                            helperText={
                                                isErrorDescriptionValidation && (
                                                    <span style={{ color: "var(--studio-btn-bg)" }}>
                                                        全角200文字（半角400文字）以内で正しく入力してください
                                                    </span>
                                                )
                                            }
                                        />
                                    </div>
                                </li>
                            )}
                        </ThemeProvider>

                        {/* 資料 */}
                        {!isEditModal && (
                            <li>
                                <div className={styles.formHelperTextLong}>資料</div>
                                <UploadDocument
                                    alreadyUploadDocumentList={
                                        alreadyUploadDocumentList ? alreadyUploadDocumentList : []
                                    }
                                    ChangeAlreadyUploadDocumentList={
                                        ChangeAlreadyUploadDocumentList
                                    }
                                    setIsSaved={setIsSaved}
                                    ChangeDocumentList={ChangeDocumentList}
                                    documentList={inputDocumentList}
                                    ChangeDocumentNameList={ChangeDocumentNameList}
                                    documentNameList={inputDocumentNameList}
                                />
                            </li>
                        )}
                        {/* タグ（モーダル表示） */}
                        <li>
                            <div className={styles.formHelperTextLong}>タグ</div>
                            {!isEditModal ? (
                                <div className={styles.formTag}>
                                    <AddCircleOutlineOutlinedIcon
                                        style={{ cursor: "pointer", color: "var(--main)" }}
                                        color="secondary"
                                        fontSize="large"
                                        onClick={OpenTagSelectModal}
                                    />
                                </div>
                            ) : (
                                <div
                                    className={styles.formTag}
                                    onMouseEnter={() => setMouseEnterInfo(true)}
                                    onMouseLeave={() => setMouseEnterInfo(false)}
                                >
                                    {!isMouseEnterInfo && (
                                        <img
                                            style={{
                                                cursor: "pointer",
                                            }}
                                            alt={"More"}
                                            onClick={OpenTagSelectModal}
                                            src={require("../../../assets/image/MoreIcon.svg")}
                                        />
                                    )}
                                    {isMouseEnterInfo && (
                                        <img
                                            style={{
                                                cursor: "pointer",
                                            }}
                                            alt={"More"}
                                            onClick={OpenTagSelectModal}
                                            src={require("../../../assets/image/MoreIcon_hover.svg")}
                                        />
                                    )}
                                </div>
                            )}
                            <div className={styles.tags}>
                                {tagList &&
                                    tagList.map((tag) => (
                                        <Chip
                                            key={tag}
                                            label={tag}
                                            color="secondary"
                                            size="medium"
                                            style={{
                                                fontFamily: "noto-sans-cjk-jp,sans-serif",
                                                backgroundColor: isEditModal
                                                    ? "var(--studio-btn-bg)"
                                                    : "var(--main)",
                                            }}
                                            className={styles.tag}
                                            onDelete={() => handleDelete(tag)}
                                        />
                                    ))}
                            </div>
                        </li>
                        {/* 編集モーダル資料 */}
                        {isEditModal && (
                            <li>
                                <div className={styles.formHelperTextLong}>資料</div>
                                <div className={styles.ed_DoumnetIcon}>
                                    <UploadDocument
                                        alreadyUploadDocumentList={
                                            alreadyUploadDocumentList
                                                ? alreadyUploadDocumentList
                                                : []
                                        }
                                        ChangeAlreadyUploadDocumentList={
                                            ChangeAlreadyUploadDocumentList
                                        }
                                        setIsSaved={setIsSaved}
                                        ChangeDocumentList={ChangeDocumentList}
                                        documentList={inputDocumentList}
                                        ChangeDocumentNameList={ChangeDocumentNameList}
                                        documentNameList={inputDocumentNameList}
                                        isShowAddDocIcon={true}
                                    />
                                </div>
                            </li>
                        )}

                        {/* グループ（モーダル表示） */}
                        {!isEditModal && (
                            <li>
                                <div className={styles.formHelperTextLong}>Group</div>
                                <div className={styles.formTag}>
                                    <AddCircleOutlineOutlinedIcon
                                        style={{ cursor: "pointer", color: "var(--main)" }}
                                        color="secondary"
                                        fontSize="large"
                                        onClick={OpenGroupSelectModal}
                                    />
                                </div>
                                <div className={styles.tags}>
                                    {group &&
                                        group.map((group) => (
                                            <Chip
                                                key={group.id}
                                                label={group.title}
                                                color="secondary"
                                                size="medium"
                                                style={{ backgroundColor: "var(--main)" }}
                                                className={styles.tag}
                                                onDelete={() => handleDeleteGroup(group.title)}
                                            />
                                        ))}
                                </div>
                            </li>
                        )}
                    </form>
                </FormControl>
            </ul>

            {/* タグ選択モーダル */}
            <Modal open={isOpenTagSelectModal} onClose={CloseTagSelectModal}>
                <SelectTag
                    in={isOpenTagSelectModal}
                    onClose={CloseTagSelectModal}
                    tagList={tagList}
                    setTagList={setTagList}
                    setIsSaved={setIsSaved}
                />
            </Modal>

            {/* グループ選択モーダル */}
            <Modal open={isOpenGroupSelectModal} onClose={CloseGroupSelectModal}>
                <SelectGroup
                    visibleModal={isOpenGroupSelectModal}
                    onClose={CloseGroupSelectModal}
                    targetName={inputSlideFileName}
                    userGroup={group}
                    SetGroupList={SetSlideGroup}
                    SetIsSaved={setIsSaved}
                />
            </Modal>

            {/* アップロードコンテンツファイルサイズチェック */}
            <PuiMessage
                open={isLimitInputFileSize}
                onClose={CloseLimitInputFileBar}
                type="error"
                title="50MB以上のファイルはアップロードできません"
                duration={5000}
            />

            {/* アップロードコンテンツファイルチェック */}
            <PuiMessage
                open={isErrorInputSize}
                type="error"
                title="正しいファイルを選択してください"
                duration={5000}
                onClose={CloseErrorInputBar}
            />

            {/* 既にファイルがアップロードして再度別のファイルをアップロードする場合、ダイアログ表示 */}
            <OnLeaveDialog
                openDialog={showSlideUploadConfirmDialog}
                dialogTitle={"コンテンツアップロード確認"}
                dialogContent={"現在アップロードしているコンテンツファイルは失われます"}
                dialogActions={"OK"}
                handleCloseDialog={handleCloseDialog}
                handleCancel={handleCancelDialog}
                handleConfirm={deleteTempFile}
            />
        </>
    );
}
